import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { Tooltip } from "antd";
import { FormattedMessage } from "react-intl";

import "./style.css";

class HeaderAddButton extends Component {
  static propTypes = {    
    navigate: PropTypes.any,
    onClick: PropTypes.func,
    isDocumentsButton: PropTypes.bool,
    isFolderButton: PropTypes.bool,
    tooltip: PropTypes.string
  };

  render() {
    const {      
      onClick,
      isDocumentsButton,
      isFolderButton,
      tooltip,
      navigate
    } = this.props;
    
    return (
      <Tooltip
        placement="top"
        color={"#005075"}
        title={
          (tooltip || isDocumentsButton || isFolderButton) && (
            <FormattedMessage
              id={
                isDocumentsButton
                  ? "documents.tooltips.addNewDocument"
                  : isFolderButton
                    ? "folders.tooltips.addNewFolder"
                    : tooltip
              }
            />
          )
        }
      >
        <div
          className="headerAddButton"
          onClick={
            isDocumentsButton
              ? () => navigate("/carica-documenti")
              : onClick || null
          }
        >
          <FontAwesomeIcon
            icon={["far", "plus"]}
            style={{ fontSize: "23px", color: "white", margin: "0 auto" }}
          />
        </div>
      </Tooltip>
    );
  }
}

export default HeaderAddButton;
